module.exports = __webpack_public_path__ + "img/781.768452a4.jpg";